'use client';

import videojs from 'video.js';

// Default options
const defaults = {
    fullscreen: {
        enterOnRotate: true,
        exitOnRotate: true,
        alwaysInLandscapeMode: true,
        iOS: true
    }
};

const initLandscapeFullscreen = (screen) => {
    screen.lockOrientationUniversal = (mode) =>
        (screen.orientation && screen.orientation.lock(mode).catch((err) => console.log(err))) ||
        (screen.mozLockOrientation && screen.mozLockOrientation(mode)) ||
        (screen.msLockOrientation && screen.msLockOrientation(mode));
};

const angle = () => {
    if (typeof window.orientation === 'number') {
        return window.orientation;
    }
    if (screen?.orientation?.angle !== undefined) {
        return screen.orientation.angle;
    }
    videojs.log('angle unknown');
    return 0;
};

const registerPlugin = videojs.registerPlugin || videojs.plugin;

// ======= NEW: DOM fullscreen checker (Fix real bug) =======
const isDOMFullscreen = () => {
    return !!(document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement);
};

// ==========================================================

const onPlayerReady = (player, options) => {
    player.addClass('vjs-landscape-fullscreen');

    // iOS inline fix
    if (options.fullscreen.iOS && videojs.browser.IS_IOS && videojs.browser.IOS_VERSION > 9) {
        player.tech_.el_.setAttribute('playsinline', 'playsinline');
        // NOTE: override removed — causes fullscreen exit errors
    }

    const rotationHandler = () => {
        const currentAngle = angle();

        // ENTER FULLSCREEN
        if (currentAngle === 90 || currentAngle === 270 || currentAngle === -90) {
            if (options.fullscreen.enterOnRotate && !isDOMFullscreen() && !player.paused()) {
                player.requestFullscreen?.();
                screen.lockOrientationUniversal('landscape');
            }
        }

        // EXIT FULLSCREEN — SAFE VERSION
        if (currentAngle === 0 || currentAngle === 180) {
            if (options.fullscreen.exitOnRotate && isDOMFullscreen()) {
                document.exitFullscreen?.().catch(() => {});
            }
        }
    };

    if (videojs.browser.IS_IOS) {
        window.addEventListener('orientationchange', rotationHandler);
    } else if (screen?.orientation) {
        screen.orientation.onchange = rotationHandler;
    }

    // Extra lock fix
    player.on('fullscreenchange', () => {
        if (
            (videojs.browser.IS_ANDROID || videojs.browser.IS_IOS) &&
            isDOMFullscreen() &&
            options.fullscreen.alwaysInLandscapeMode
        ) {
            screen.lockOrientationUniversal('landscape');
        }
    });

    player.on('dispose', () => {
        window.removeEventListener('orientationchange', rotationHandler);
    });
};

const landscapeFullscreen = function (screen, options) {
    initLandscapeFullscreen(screen);
    if (videojs.browser.IS_ANDROID || videojs.browser.IS_IOS) {
        this.ready(() => {
            onPlayerReady(this, videojs.mergeOptions(defaults, options));
        });
    }
};

registerPlugin('landscapeFullscreen', landscapeFullscreen);

export default landscapeFullscreen;

